export * from './age-confirmation.store';
